// AJAX Contact Form Handler
// Handles form submission to custom server endpoint with modal feedback and character counting

(function() {
    'use strict';
    
    let isSubmitting = false;
    let form = null;
    let textarea = null;
    let characterCounter = null;
    
    // Function to create and show loading modal
    function showLoadingModal() {
        // Remove any existing modal
        const existingModal = document.getElementById('loading-modal');
        if (existingModal) {
            existingModal.remove();
        }
        
        // Create loading modal HTML
        const modalHTML = `
            <div id="loading-modal" style="
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: rgba(0, 0, 0, 0.5);
                display: flex;
                justify-content: center;
                align-items: center;
                z-index: 10000;
                font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
            ">
                <div style="
                    background: white;
                    padding: 40px;
                    border-radius: 12px;
                    text-align: center;
                    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
                    animation: modalSlideIn 0.3s ease-out;
                ">
                    <div style="
                        width: 40px;
                        height: 40px;
                        border: 4px solid #f3f3f3;
                        border-top: 4px solid #63308A;
                        border-radius: 50%;
                        animation: spin 1s linear infinite;
                        margin: 0 auto 20px;
                    "></div>
                    
                    <h3 style="
                        color: #374151;
                        font-size: 20px;
                        font-weight: 600;
                        margin-bottom: 10px;
                    ">Sending Your Message</h3>
                    
                    <p style="
                        color: #6B7280;
                        font-size: 16px;
                        margin: 0;
                    ">Please wait while we submit your information...</p>
                </div>
            </div>
            <style>
                @keyframes modalSlideIn {
                    from {
                        opacity: 0;
                        transform: translateY(-20px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
            </style>
        `;
        
        // Insert modal into DOM
        document.body.insertAdjacentHTML('beforeend', modalHTML);
        console.log('Loading modal displayed');
    }
    
    // Function to create and show success modal
    function showSuccessModal() {
        // Remove loading modal first
        const loadingModal = document.getElementById('loading-modal');
        if (loadingModal) {
            loadingModal.remove();
        }
        
        // Remove any existing success modal
        const existingModal = document.getElementById('success-modal');
        if (existingModal) {
            existingModal.remove();
        }
        
        // Create success modal HTML
        const modalHTML = `
            <div id="success-modal" style="
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: rgba(0, 0, 0, 0.5);
                display: flex;
                justify-content: center;
                align-items: center;
                z-index: 10000;
                font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
            ">
                <div style="
                    background: white;
                    padding: 40px;
                    border-radius: 16px;
                    max-width: 493px;
                    width: 90%;
                    text-align: left;
                    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
                    position: relative;
                    animation: modalSlideIn 0.3s ease-out;
                ">
                    <button id="close-success-modal" style="
                        position: absolute;
                        top: 15px;
                        right: 15px;
                        background: none;
                        border: none;
                        font-size: 24px;
                        cursor: pointer;
                        color: #666;
                        padding: 5px;
                        line-height: 1;
                    ">&times;</button>
                    
                    <h2 style="
                        font-family: var(--font-body);
                        color: #63308A;
                        font-size: 24px;
                        font-weight: 600;
                        margin: 0 0 20px;
                        line-height: 1.3;
                    ">Thank you for reaching out!</h2>
                    
                    <p style="
                        color: #303132;
                        font-size: 16px;
                        line-height: 1.6;
                        margin: 0 0 20px;
                    ">Your message matters, and we will answer with compassionate care and support—as soon as possible.</p>
                    
                    <div style="
                        font-size: 14px;
                        color: #6B7280;
                        margin: 0;
                    ">
                        <p style="margin: 0;">While you wait, check out our <a href="/pages/faq" style="color: #63308A; text-decoration: underline;">help center</a>.</p>
                    </div>
                </div>
            </div>
        `;
        
        // Insert modal into DOM
        document.body.insertAdjacentHTML('beforeend', modalHTML);
        
        // Add event listeners
        const modal = document.getElementById('success-modal');
        const closeBtn = document.getElementById('close-success-modal');
        
        // Close modal when clicking X button
        closeBtn.addEventListener('click', function() {
            modal.remove();
        });
        
        // Close modal when clicking outside
        modal.addEventListener('click', function(e) {
            if (e.target === modal) {
                modal.remove();
            }
        });
        
        // Close modal with Escape key
        const escapeHandler = function(e) {
            if (e.key === 'Escape' && document.getElementById('success-modal')) {
                modal.remove();
                document.removeEventListener('keydown', escapeHandler);
            }
        };
        document.addEventListener('keydown', escapeHandler);
        
        console.log('Success modal displayed');
    }
    
    // Function to create and show error modal
    function showErrorModal(errorMessage, errors = []) {
        // Remove any existing modals
        const existingModal = document.getElementById('error-modal');
        if (existingModal) {
            existingModal.remove();
        }
        
        const loadingModal = document.getElementById('loading-modal');
        if (loadingModal) {
            loadingModal.remove();
        }
        
        // Generate error list HTML if specific errors provided
        let errorListHTML = '';
        if (errors.length > 0) {
            errorListHTML = '<ul style="text-align: left; margin: 20px 0; padding-left: 20px; color: #dc2626;">';
            errors.forEach(error => {
                errorListHTML += `<li style="margin-bottom: 8px;"><strong>${error.field}:</strong> ${error.message}</li>`;
            });
            errorListHTML += '</ul>';
        }
        
        // Create error modal HTML
        const modalHTML = `
            <div id="error-modal" style="
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: rgba(0, 0, 0, 0.5);
                display: flex;
                justify-content: center;
                align-items: center;
                z-index: 10000;
                font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
            ">
                <div style="
                    background: white;
                    padding: 40px;
                    border-radius: 12px;
                    max-width: 450px;
                    width: 90%;
                    text-align: center;
                    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
                    position: relative;
                    animation: modalSlideIn 0.3s ease-out;
                    border-top: 4px solid #dc2626;
                ">
                    <button id="close-error-modal" style="
                        position: absolute;
                        top: 15px;
                        right: 15px;
                        background: none;
                        border: none;
                        font-size: 24px;
                        cursor: pointer;
                        color: #666;
                        padding: 5px;
                        line-height: 1;
                    ">&times;</button>
                    
                    <div style="
                        width: 60px;
                        height: 60px;
                        border-radius: 50%;
                        background-color: #fee2e2;
                        margin: 0 auto 20px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    ">
                        <span style="
                            color: #dc2626;
                            font-size: 30px;
                            font-weight: bold;
                        ">!</span>
                    </div>
                    
                    <h2 style="
                        color: #dc2626;
                        font-size: 22px;
                        font-weight: 600;
                        margin-bottom: 15px;
                    ">Submission Error</h2>
                    
                    <p style="
                        color: #374151;
                        font-size: 16px;
                        line-height: 1.5;
                        margin-bottom: 10px;
                    ">${errorMessage}</p>
                    
                    ${errorListHTML}
                    
                    <button id="try-again-btn" style="
                        background-color: #dc2626;
                        color: white;
                        border: none;
                        padding: 12px 24px;
                        border-radius: 6px;
                        font-size: 16px;
                        font-weight: 500;
                        cursor: pointer;
                        margin-top: 10px;
                        transition: background-color 0.2s;
                    " onmouseover="this.style.backgroundColor='#b91c1c'" onmouseout="this.style.backgroundColor='#dc2626'">
                        Try Again
                    </button>
                </div>
            </div>
        `;
        
        // Insert modal into DOM
        document.body.insertAdjacentHTML('beforeend', modalHTML);
        
        // Add event listeners
        const modal = document.getElementById('error-modal');
        const closeBtn = document.getElementById('close-error-modal');
        const tryAgainBtn = document.getElementById('try-again-btn');
        
        // Close modal when clicking X button or Try Again
        [closeBtn, tryAgainBtn].forEach(btn => {
            btn.addEventListener('click', function() {
                modal.remove();
            });
        });
        
        // Close modal when clicking outside
        modal.addEventListener('click', function(e) {
            if (e.target === modal) {
                modal.remove();
            }
        });
        
        // Close modal with Escape key
        const escapeHandler = function(e) {
            if (e.key === 'Escape' && document.getElementById('error-modal')) {
                modal.remove();
                document.removeEventListener('keydown', escapeHandler);
            }
        };
        document.addEventListener('keydown', escapeHandler);
        
        console.log('Error modal displayed');
    }
    
    // Function to validate form fields
    function validateForm(formData) {
        const errors = [];
        
        // Define required fields with validation rules
        const requiredFields = [
            { 
                name: 'name', 
                displayName: 'Name',
                type: 'text',
                minLength: 2,
                maxLength: 100
            },
            { 
                name: 'email', 
                displayName: 'Email',
                type: 'email'
            },
            { 
                name: 'topic', 
                displayName: 'Topic',
                type: 'text',
                minLength: 2,
                maxLength: 200
            },
            { 
                name: 'concerns', 
                displayName: 'Concerns',
                type: 'textarea',
                minLength: 10,
                maxLength: 2000
            }
        ];
        
        console.log('Validating form fields...');
        
        // Check required fields
        requiredFields.forEach(field => {
            const value = formData.get(field.name) ? formData.get(field.name).toString().trim() : '';
            
            console.log(`Checking ${field.displayName}: "${value}" (length: ${value.length})`);
            
            // Required field check
            if (!value) {
                errors.push({
                    field: field.displayName,
                    message: 'This field is required'
                });
                addFieldError(field.name);
                return;
            }
            
            // Length validations
            if (field.minLength && value.length < field.minLength) {
                errors.push({
                    field: field.displayName,
                    message: `Must be at least ${field.minLength} characters`
                });
                addFieldError(field.name);
            }
            
            if (field.maxLength && value.length > field.maxLength) {
                errors.push({
                    field: field.displayName,
                    message: `Must be no more than ${field.maxLength} characters`
                });
                addFieldError(field.name);
            }
            
            // Email-specific validation
            if (field.type === 'email' && value) {
                const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
                
                if (!emailRegex.test(value)) {
                    errors.push({
                        field: field.displayName,
                        message: 'Please enter a valid email address'
                    });
                    addFieldError(field.name);
                } else if (value.length < 5 || value.length > 254) {
                    errors.push({
                        field: field.displayName,
                        message: 'Email must be between 5 and 254 characters'
                    });
                    addFieldError(field.name);
                } else if (value.includes('..') || value.startsWith('.') || value.endsWith('.')) {
                    errors.push({
                        field: field.displayName,
                        message: 'Invalid email format'
                    });
                    addFieldError(field.name);
                }
            }
            
            // Name-specific validation
            if (field.name === 'name' && value) {
                const nameRegex = /^[a-zA-Z\s\-\.\']+$/;
                if (!nameRegex.test(value)) {
                    errors.push({
                        field: field.displayName,
                        message: 'Name can only contain letters, spaces, hyphens, periods, and apostrophes'
                    });
                    addFieldError(field.name);
                }
            }
        });
        
        console.log(`Validation complete. Found ${errors.length} errors.`);
        return errors;
    }
    
    // Function to add visual error styling to form field
    function addFieldError(fieldName) {
        const field = form.querySelector(`[name="${fieldName}"]`);
        if (!field) return;
        
        // Add error styling
        field.style.border = '2px solid #dc2626';
        field.style.boxShadow = '0 0 0 3px rgba(220, 38, 38, 0.1)';
        
        // Add error class for animation
        field.classList.add('form-field-error');
        
        // Add CSS for shake animation if not already present
        if (!document.querySelector('#form-error-styles')) {
            const styles = document.createElement('style');
            styles.id = 'form-error-styles';
            styles.textContent = `
                .form-field-error {
                    animation: fieldShake 0.5s ease-in-out;
                }
                
                @keyframes fieldShake {
                    0%, 100% { transform: translateX(0); }
                    10%, 30%, 50%, 70%, 90% { transform: translateX(-5px); }
                    20%, 40%, 60%, 80% { transform: translateX(5px); }
                }
            `;
            document.head.appendChild(styles);
        }
        
        // Remove animation class after it completes
        setTimeout(() => {
            field.classList.remove('form-field-error');
        }, 500);
    }
    
    // Function to remove error styling from form field
    function removeFieldError(fieldName) {
        const field = form.querySelector(`[name="${fieldName}"]`);
        if (!field) return;
        
        // Remove error styling
        field.style.border = '';
        field.style.boxShadow = '';
        field.classList.remove('form-field-error');
    }
    
    // Function to clear all form fields after successful submission
    function clearForm() {
        if (!form) return;
        
        console.log('Clearing form fields...');
        
        // Clear text inputs
        const textInputs = form.querySelectorAll('input[type="text"], input[type="email"]');
        textInputs.forEach(input => {
            input.value = '';
            removeFieldError(input.name);
        });
        
        // Clear textarea
        if (textarea) {
            textarea.value = '';
            removeFieldError(textarea.name);
            updateCharacterCount();
        }
        
        console.log('Form cleared successfully');
    }
    
    // Function to update character counter
    function updateCharacterCount() {
        if (!textarea || !characterCounter) return;
        
        const currentLength = textarea.value.length;
        const maxLength = parseInt(textarea.getAttribute('maxlength')) || 2000;
        const characterCountSpan = characterCounter.querySelector('.character-count');
        
        if (characterCountSpan) {
            characterCountSpan.textContent = currentLength;
        }
        
        // Update counter color based on usage
        characterCounter.classList.remove('warning', 'danger');
        
        const percentUsed = (currentLength / maxLength) * 100;
        if (percentUsed >= 90) {
            characterCounter.classList.add('danger');
        } else if (percentUsed >= 75) {
            characterCounter.classList.add('warning');
        }
    }
    
    // Function to handle form submission
    async function handleFormSubmit(e) {
        e.preventDefault();
        
        // Prevent double submission
        if (isSubmitting) {
            console.log('Form submission already in progress');
            return;
        }
        
        console.log('Starting form submission...');
        isSubmitting = true;
        
        // Get form data
        const formData = new FormData(form);
        
        // Add shop parameter from form's data attribute
        const shopDomain = form.getAttribute('data-shop') || 'iam-ateststore123';
        formData.set('shop', shopDomain);
        
        // Client-side validation
        const validationErrors = validateForm(formData);
        if (validationErrors.length > 0) {
            console.log('Client-side validation failed:', validationErrors);
            showErrorModal('Please correct the following errors:', validationErrors);
            isSubmitting = false;
            return;
        }
        
        // Clear any existing field errors since validation passed
        const allFields = ['name', 'email', 'topic', 'concerns'];
        allFields.forEach(fieldName => {
            removeFieldError(fieldName);
        });
        
        // Show loading modal
        showLoadingModal();
        
        // Get submit button and show loading state
        const submitButton = form.querySelector('button[type="submit"]');
        const originalButtonText = submitButton ? submitButton.textContent : '';
        if (submitButton) {
            submitButton.disabled = true;
            submitButton.textContent = 'Sending...';
        }
        
        try {
            // Build full endpoint URL from ENV_CONFIG base + endpoint path
            // App: /apps/api/clients/submit_contact
            const endpointPath = form.dataset.endpointPath || '/clients/submit_contact';
            const endpoint = window.ENV_CONFIG?.getProxyUrl(endpointPath) || endpointPath;

            console.log('Environment:', window.ENV_CONFIG?.environment);
            console.log('Endpoint Path:', endpointPath);
            console.log('Full Endpoint:', endpoint);
            console.log('Form data:', {
                name: formData.get('name'),
                email: formData.get('email'),
                topic: formData.get('topic'),
                concerns: formData.get('concerns'),
                shop: formData.get('shop')
            });
            
            // Submit to server with URL-encoded format
            const response = await fetch(endpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: new URLSearchParams(formData)
            });
            
            console.log('Server response status:', response.status);
            
            if (!response.ok) {
                throw new Error(`HTTP ${response.status}: Server error`);
            }
            
            // Success - clear form and show success modal
            console.log('Form submission successful');
            clearForm();
            showSuccessModal();
            
        } catch (error) {
            console.error('Form submission error:', error);
            
            // Handle different types of errors
            let errorMessage = 'There was an error submitting your message. Please try again.';
            
            if (error.message.includes('Failed to fetch') || error.name === 'TypeError') {
                errorMessage = 'Unable to connect to the server. Please check your internet connection and try again.';
            } else if (error.message.includes('HTTP 400')) {
                errorMessage = 'There was a validation error. Please check your information and try again.';
            } else if (error.message.includes('HTTP 500') || error.message.includes('HTTP 502') || error.message.includes('HTTP 503')) {
                errorMessage = 'Server error. Please try again in a few moments.';
            }
            
            showErrorModal(errorMessage);
        } finally {
            // Reset submission state and button
            isSubmitting = false;
            if (submitButton) {
                submitButton.disabled = false;
                submitButton.textContent = originalButtonText;
            }
        }
    }
    
    // Function to set up input field validation listeners
    function setupFieldValidation() {
        const allFields = ['name', 'email', 'topic', 'concerns'];
        
        allFields.forEach(fieldName => {
            const field = form.querySelector(`[name="${fieldName}"]`);
            if (field) {
                // Clear error styling when user interacts with field
                const clearError = () => removeFieldError(fieldName);
                
                field.addEventListener('input', clearError);
                field.addEventListener('change', clearError);
                field.addEventListener('focus', clearError);
            }
        });
        
        console.log('Field validation listeners set up');
    }
    
    // Function to set up character counter
    function setupCharacterCounter() {
        textarea = form.querySelector('textarea[name="concerns"]');
        characterCounter = form.querySelector('.character-counter');
        
        if (textarea && characterCounter) {
            // Update counter on input
            textarea.addEventListener('input', updateCharacterCount);
            
            // Initialize counter
            updateCharacterCount();
            
            console.log('Character counter initialized');
        }
    }
    
    // Main initialization function
    function initializeForm() {
        // Find the form
        form = document.querySelector('.contact-form__form');
        
        if (!form) {
            console.log('Contact form not found, retrying...');
            setTimeout(initializeForm, 100);
            return;
        }
        
        console.log('Contact form found, initializing AJAX handler...');
        
        // Set up form submission handler
        form.addEventListener('submit', handleFormSubmit);
        
        // Set up field validation
        setupFieldValidation();
        
        // Set up character counter
        setupCharacterCounter();
        
        console.log('AJAX form handler initialized successfully');
    }
    
    // Start when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeForm);
    } else {
        initializeForm();
    }
    
})();